// NATURALS BLESSING — PRODUCT SECTIONS AJAX LOADER
// Loads FBT (Frequently Bought Together) and YMAL (You Might Also Like)
// sections via Shopify AJAX API after page paint.
// This eliminates all_products[] server-side lookups, reducing TTFB by ~400ms.

(function() {
  'use strict';

  // ─── FBT PRODUCT MAP ────────────────────────────────────────────────────────
  // Maps product handle → [fbt_h1, fbt_h2]
  var FBT_MAP = {
    'batana-growth-serum': ['baldopecia-growth-serum', 'rapid-growth-night-serum'],
    'baldopecia-growth-serum': ['batana-growth-serum', 'bfcm-day-serum'],
    'batana-all-natural-hair-growth-oil': ['batana-growth-serum', 'rapid-growth-night-serum'],
    'rapid-growth-night-serum': ['bfcm-day-serum', 'batana-growth-serum'],
    'bfcm-day-serum': ['rapid-growth-night-serum', 'batana-growth-serum'],
    'black-rice-water-shampoo': ['black-rice-water-conditioner', 'batana-growth-serum'],
    'black-rice-water-conditioner': ['black-rice-water-shampoo', 'batana-growth-serum'],
    'black-rice-water': ['black-rice-water-shampoo', 'batana-growth-serum'],
    'thickening-shampoo': ['thickening-conditioner', 'batana-growth-serum'],
    'thickening-conditioner': ['thickening-shampoo', 'batana-growth-serum'],
    'chebe-growth-spray': ['chebe-growth-conditioner', 'batana-growth-serum'],
    'chebe-growth-conditioner': ['chebe-growth-spray', 'batana-growth-serum'],
    'straight-detangling-spray': ['batana-growth-serum', 'rapid-growth-night-serum'],
    'wash-and-grow-kit': ['batana-growth-serum', 'rapid-growth-night-serum'],
    'rapid-action-hair-growth-kit-w-free-satin-bonnet': ['batana-growth-serum', 'baldopecia-growth-serum'],
    'scalp-refresh-reset-2': ['batana-growth-serum', 'baldopecia-growth-serum'],
    'scalp-refresh-reset-1': ['batana-growth-serum', 'baldopecia-growth-serum'],
    'skincare-brightening-kit': ['brightening-vitamin-c-facial-toner-mist', 'facial-serum'],
    'brightening-vitamin-c-facial-toner-mist': ['skincare-brightening-kit', 'facial-serum'],
    'facial-serum': ['brightening-vitamin-c-facial-toner-mist', 'facial-glow'],
    'facial-glow': ['facial-serum', 'brightening-vitamin-c-facial-toner-mist'],
    'whipped-shea-butter': ['cocoa-butter', 'facial-serum'],
    'cocoa-butter': ['whipped-shea-butter', 'facial-serum'],
    'elderberry-gummies': ['oregano-black-seed-oil-softgels', 'naturals-blessing-ethiopian-black-seed-oil-softgels'],
    'oregano-black-seed-oil-softgels': ['elderberry-gummies', 'naturals-blessing-ethiopian-black-seed-oil-softgels'],
    'naturals-blessing-ethiopian-black-seed-oil-softgels': ['elderberry-gummies', 'oregano-black-seed-oil-softgels'],
    'naturals-blessing-soursop-bitters-graviola-extract-capsules': ['elderberry-gummies', 'oregano-black-seed-oil-softgels'],
    'rapid-grease': ['batana-growth-serum', 'baldopecia-growth-serum']
  };

  // ─── YMAL PRODUCT MAP ───────────────────────────────────────────────────────
  // Maps product type → comma-separated handles
  var YMAL_MAP = {
    'SKINCARE': 'skincare-brightening-kit,brightening-vitamin-c-facial-toner-mist,facial-serum,facial-glow,whipped-shea-butter,cocoa-butter',
    'Skincare': 'skincare-brightening-kit,brightening-vitamin-c-facial-toner-mist,facial-serum,facial-glow,whipped-shea-butter,cocoa-butter',
    'Supplements': 'elderberry-gummies,oregano-black-seed-oil-softgels,naturals-blessing-ethiopian-black-seed-oil-softgels,naturals-blessing-soursop-bitters-graviola-extract-capsules',
    'Herbal Supplement': 'elderberry-gummies,oregano-black-seed-oil-softgels,naturals-blessing-ethiopian-black-seed-oil-softgels,naturals-blessing-soursop-bitters-graviola-extract-capsules',
    'Herbal Wellness': 'elderberry-gummies,oregano-black-seed-oil-softgels,naturals-blessing-ethiopian-black-seed-oil-softgels,naturals-blessing-soursop-bitters-graviola-extract-capsules',
    'Wellness': 'elderberry-gummies,oregano-black-seed-oil-softgels,naturals-blessing-ethiopian-black-seed-oil-softgels,naturals-blessing-soursop-bitters-graviola-extract-capsules',
    'Hair Loss Treatments': 'batana-growth-serum,baldopecia-growth-serum,rapid-growth-night-serum,bfcm-day-serum,black-rice-water-shampoo,thickening-shampoo,thickening-conditioner,black-rice-water-conditioner',
    'Hair Care Kits': 'wash-and-grow-kit,rapid-action-hair-growth-kit-w-free-satin-bonnet,scalp-refresh-reset-2,batana-growth-serum,baldopecia-growth-serum',
    'Hair Care Kit': 'wash-and-grow-kit,rapid-action-hair-growth-kit-w-free-satin-bonnet,scalp-refresh-reset-2,batana-growth-serum,baldopecia-growth-serum',
    'Hair Styling Products': 'straight-detangling-spray,chebe-growth-spray,batana-growth-serum,baldopecia-growth-serum,rapid-growth-night-serum,bfcm-day-serum',
    '__default__': 'batana-growth-serum,baldopecia-growth-serum,rapid-growth-night-serum,bfcm-day-serum,black-rice-water-shampoo,thickening-shampoo,thickening-conditioner,black-rice-water-conditioner'
  };

  // ─── PRODUCT FETCH CACHE ────────────────────────────────────────────────────
  var productCache = {};

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (p) productCache[handle] = p;
        return p;
      })
      .catch(function() { return null; });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ─── FBT LOADER ─────────────────────────────────────────────────────────────
  function loadFBT() {
    var fbtSection = document.getElementById('fbt-section');
    if (!fbtSection) return;

    var handle = fbtSection.getAttribute('data-product-handle');
    var productId = parseInt(fbtSection.getAttribute('data-product-id'), 10);
    var productPrice = parseInt(fbtSection.getAttribute('data-product-price'), 10);
    var productTitle = fbtSection.getAttribute('data-product-title');
    var productUrl = fbtSection.getAttribute('data-product-url');
    var productImage = fbtSection.getAttribute('data-product-image');

    var fbtHandles = FBT_MAP[handle] || FBT_MAP['__default__'] || [];
    if (!fbtHandles || fbtHandles.length === 0) return;

    var h1 = fbtHandles[0];
    var h2 = fbtHandles[1];

    Promise.all([fetchProduct(h1), h2 ? fetchProduct(h2) : Promise.resolve(null)])
      .then(function(products) {
        var p1 = products[0];
        var p2 = products[1];

        if (!p1 && !p2) return;

        var fbtProducts = document.getElementById('fbt-products');
        if (!fbtProducts) return;

        // Current product card
        var currentCard = '<div class="fbt-product-card">';
        if (productImage) {
          currentCard += '<a href="' + productUrl + '"><img src="' + productImage + '" alt="' + productTitle + '" loading="lazy" width="200" height="200"></a>';
        }
        currentCard += '<span class="fbt-card-title">' + productTitle.substring(0, 35) + '</span>';
        currentCard += '<span class="fbt-card-price">' + formatMoney(productPrice) + '</span>';
        currentCard += '</div>';

        var html = currentCard;
        var bundleTotal = productPrice;
        var variantIds = [productId];

        if (p1 && p1.available) {
          var p1Img = p1.featured_image ? p1.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_200x200.$1') : '';
          html += '<span class="fbt-plus">+</span>';
          html += '<div class="fbt-product-card">';
          html += '<a href="/products/' + p1.handle + '"><img src="' + p1Img + '" alt="' + p1.title + '" loading="lazy" width="200" height="200"></a>';
          html += '<span class="fbt-card-title">' + p1.title.substring(0, 35) + '</span>';
          html += '<span class="fbt-card-price">' + formatMoney(p1.price) + '</span>';
          html += '</div>';
          bundleTotal += p1.price;
          if (p1.variants && p1.variants[0]) variantIds.push(p1.variants[0].id);
        }

        if (p2 && p2.available) {
          var p2Img = p2.featured_image ? p2.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_200x200.$1') : '';
          html += '<span class="fbt-plus">+</span>';
          html += '<div class="fbt-product-card">';
          html += '<a href="/products/' + p2.handle + '"><img src="' + p2Img + '" alt="' + p2.title + '" loading="lazy" width="200" height="200"></a>';
          html += '<span class="fbt-card-title">' + p2.title.substring(0, 35) + '</span>';
          html += '<span class="fbt-card-price">' + formatMoney(p2.price) + '</span>';
          html += '</div>';
          bundleTotal += p2.price;
          if (p2.variants && p2.variants[0]) variantIds.push(p2.variants[0].id);
        }

        fbtProducts.innerHTML = html;

        // Update bundle total
        var totalEl = document.getElementById('fbt-bundle-total');
        if (totalEl) totalEl.textContent = formatMoney(bundleTotal);

        // Wire up the bundle button
        var bundleBtn = document.getElementById('fbt-bundle-btn');
        if (bundleBtn) {
          bundleBtn.setAttribute('data-variant-ids', variantIds.join(','));
          bundleBtn.addEventListener('click', function() {
            addFBTBundle(variantIds, bundleBtn);
          });
          var bundleRow = document.getElementById('fbt-bundle-row');
          if (bundleRow) bundleRow.style.display = '';
        }

        // Show the section
        fbtSection.style.display = '';
      });
  }

  // ─── FBT ADD TO CART ────────────────────────────────────────────────────────
  function addFBTBundle(variantIds, btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var items = variantIds.map(function(id) { return { id: id, quantity: 1 }; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = '✓ Added to Cart!';
      btn.style.background = '#145022';
      if (typeof openCartDrawerNK === 'function') openCartDrawerNK();
      else if (typeof openCartDrawer === 'function') openCartDrawer();
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = 'Add All to Cart';
        btn.style.background = '';
      }, 2500);
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = 'Add All to Cart';
    });
  }

  // ─── YMAL LOADER ────────────────────────────────────────────────────────────
  function loadYMAL() {
    var ymalSection = document.getElementById('ymal-section');
    if (!ymalSection) return;

    var productType = ymalSection.getAttribute('data-product-type') || '';
    var currentHandle = ymalSection.getAttribute('data-product-handle') || '';

    var handlesStr = YMAL_MAP[productType] || YMAL_MAP['__default__'] || '';
    var handles = handlesStr.split(',').filter(function(h) {
      return h && h !== currentHandle;
    }).slice(0, 8);

    if (handles.length === 0) return;

    Promise.all(handles.map(fetchProduct))
      .then(function(products) {
        var ymalGrid = document.getElementById('ymal-grid');
        if (!ymalGrid) return;

        var html = '';
        products.forEach(function(p) {
          if (!p || !p.available) return;
          var img = p.featured_image ? p.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_300x300.$1') : '';
          html += '<a href="/products/' + p.handle + '" class="ymal-card">';
          if (img) html += '<img src="' + img + '" alt="' + p.title + '" loading="lazy" width="300" height="300">';
          html += '<div class="ymal-card-info">';
          html += '<div class="ymal-card-title">' + p.title.substring(0, 40) + '</div>';
          html += '<div class="ymal-card-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>';
          html += '<div class="ymal-card-price">' + formatMoney(p.price) + '</div>';
          html += '</div></a>';
        });

        if (html) {
          ymalGrid.innerHTML = html;
          ymalSection.style.display = '';
        }
      });
  }

  // ─── INIT ────────────────────────────────────────────────────────────────────
  // Load FBT and YMAL after page paint using requestIdleCallback or setTimeout
  function initProductSections() {
    if (document.getElementById('fbt-section') || document.getElementById('ymal-section')) {
      if (window.requestIdleCallback) {
        requestIdleCallback(function() {
          loadFBT();
          loadYMAL();
        }, { timeout: 2000 });
      } else {
        setTimeout(function() {
          loadFBT();
          loadYMAL();
        }, 100);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSections);
  } else {
    initProductSections();
  }

})();
